var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.localValue.length > 0
      ? _c(
          "div",
          { staticClass: "grid gap-[19px]" },
          [
            _vm._l(_vm.localValue, function(education, index) {
              return _c(
                "div",
                {
                  staticClass: "grid lg:grid-cols-2 gap-[19px] p-16 bg-gray-200"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "lg:col-span-2 flex items-center justify-between"
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "font-bold text-20 text-brown-400" },
                        [_vm._v("Opleiding " + _vm._s(index + 1))]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex ml-auto items-center text-red cursor-pointer p-8 hover:bg-white w-[50px] justify-center rounded-md transition-colors",
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.remove(index)
                            }
                          }
                        },
                        [_c("i", { staticClass: "far fa-trash" })]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "grid gap-[19px]" },
                    [
                      _c("FormInput", {
                        attrs: { placeholder: "Titel" },
                        model: {
                          value: education.title,
                          callback: function($$v) {
                            _vm.$set(education, "title", $$v)
                          },
                          expression: "education.title"
                        }
                      }),
                      _vm._v(" "),
                      _c("FormInput", {
                        attrs: { placeholder: "Instituut" },
                        model: {
                          value: education.institution,
                          callback: function($$v) {
                            _vm.$set(education, "institution", $$v)
                          },
                          expression: "education.institution"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "grid md:grid-cols-2 gap-[19px]" },
                        [
                          _c("FormDate", {
                            attrs: { placeholder: "Van" },
                            model: {
                              value: education.date_from,
                              callback: function($$v) {
                                _vm.$set(education, "date_from", $$v)
                              },
                              expression: "education.date_from"
                            }
                          }),
                          _vm._v(" "),
                          _c("FormDate", {
                            attrs: { placeholder: "Tot" },
                            model: {
                              value: education.date_to,
                              callback: function($$v) {
                                _vm.$set(education, "date_to", $$v)
                              },
                              expression: "education.date_to"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("FormTextarea", {
                    attrs: { placeholder: "Beschijving" },
                    model: {
                      value: education.short_description,
                      callback: function($$v) {
                        _vm.$set(education, "short_description", $$v)
                      },
                      expression: "education.short_description"
                    }
                  })
                ],
                1
              )
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex w-full justify-center items-center" },
              [
                _c(
                  "button",
                  {
                    staticClass:
                      "bg-orange font-medium rounded-full text-white px-24 py-[7px] mb-8",
                    attrs: { type: "button" },
                    on: { click: _vm.addNew }
                  },
                  [
                    _vm._v(
                      "\n                Opleidingen toevoegen\n            "
                    )
                  ]
                )
              ]
            )
          ],
          2
        )
      : _c(
          "div",
          {
            staticClass:
              "h-auto min-h-[250px] p-16 cursor-pointer flex flex-col items-center justify-center px-16 font-bold text-20  placeholder-brown-400 bg-white gap-[19px]"
          },
          [
            _c("div", [_vm._v(_vm._s(_vm.placeholder))]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass:
                  "bg-orange font-medium rounded-full text-white px-24 py-[7px] mb-8",
                attrs: { type: "button" },
                on: { click: _vm.addNew }
              },
              [_vm._v("\n            Opleidingen toevoegen\n        ")]
            )
          ]
        )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }